import { useTranslation } from 'react-i18next';

import { EmptyDataMessage } from '@/ui';
import type { CallWithIncidentId } from './incidentListSelectors';
import { CallNotificationListComponent } from './CallNotificationListComponent';
import { CallNotificationsListItemPlaceholder } from '@/features/shared/IncidentListLoadingPlaceholder';

export type CallNotificationListProps = {
  callNotifications?: readonly CallWithIncidentId[];
  isLoading?: boolean;
};

export function CallNotificationList({ callNotifications, isLoading = false }: CallNotificationListProps) {
  const { t } = useTranslation();

  return (
    <div className="p-2 mt-2">
      <h2>{t('CallNotification_IncomingCalls')}</h2>

      {isLoading ? (
        <CallNotificationsListItemPlaceholder />
      ) : callNotifications != null && callNotifications.length > 0 ? (
        <CallNotificationListComponent callNotifications={callNotifications} />
      ) : (
        <EmptyDataMessage text={t('CallNotification_NoRecentCallNotifications')} />
      )}
    </div>
  );
}
